<div class="feature-stats">
  <table>
    <ng-container *ngFor="let summGroup of featureTypeSummaries; let i=index">
    <thead>
      <tr>
        <th>{{summGroup[0]}}</th>
        <th *ngIf="i == 0" class="num">Total</th>
        <ng-container *ngIf="i == 0">
        <th class="num" *ngFor="let chr of appConfig.chromosomes">
          {{chr.short_display_name}}
        </th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let featureType of summGroup[1]">
        <td>
          {{featureType.display_type_name}}
        </td>
        <td class="num">
          <span *ngIf="featureType.is_gene_type">
            <a title="Click to view all {{featureType.display_type_name}} features"
               routerLink="{{makeFeatureGenesLink(featureType.type_name)}}">
              {{total(featureType)}}
            </a>
          </span>
          <span *ngIf="!featureType.is_gene_type">
            {{total(featureType)}}
          </span>
        </td>
        <td class="num" *ngFor="let chr of appConfig.chromosomes">
          <span *ngIf="featureType.is_gene_type">
            <a *ngIf="featureType.by_chromosome[chr.name]"
               title="Click to view {{featureType.display_type_name}} features from {{chr.long_display_name}}"
               routerLink="{{makeChrGenesLink(chr.name, featureType.type_name)}}">
              {{featureType.by_chromosome[chr.name]}}
            </a>
          </span>
          <span *ngIf="!featureType.is_gene_type">
          {{featureType.by_chromosome[chr.name] || ''}}
          </span>
        </td>
      </tr>
    </tbody>
    </ng-container>

  </table>

</div>
